import { useState, useEffect } from "react";
import axios from "axios";
import API_URL from "../config/config";
import "../css/addresses.css";

import {
  FaMapMarkerAlt,
  FaPlus,
  FaTrash,
  FaEdit,
  FaSave,
  FaTimes
} from "react-icons/fa";

function Addresses() {
  const userId = localStorage.getItem("user_id");

  const emptyAddress = {
    full_name: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip_code: "",
    country: ""
  };

  const [addresses, setAddresses] = useState([]);
  const [newAddress, setNewAddress] = useState(emptyAddress);

  const [editingId, setEditingId] = useState(null);
  const [editAddress, setEditAddress] = useState(emptyAddress);

  useEffect(() => {
    if (userId) {
      loadAddresses();
    }
  }, [userId]);

  // Load Addresses
  const loadAddresses = () => {
    axios
      .get(`${API_URL}/addresses/${userId}`)
      .then((res) => {
        setAddresses(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Add Form Change
  const handleChange = (e) => {
    setNewAddress({
      ...newAddress,
      [e.target.name]: e.target.value
    });
  };

  // Add Address
  const addAddress = (e) => {
    e.preventDefault();

    if (
      !newAddress.full_name ||
      !newAddress.phone ||
      !newAddress.address
    ) {
      alert("Please fill all required fields.");
      return;
    }

    axios
      .post(`${API_URL}/addresses`, {
        user_id: Number(userId),
        ...newAddress
      })
      .then(() => {
        alert("Address Added Successfully");
        setNewAddress(emptyAddress);
        loadAddresses();
      })
      .catch((err) => {
        console.log(err);
        alert("Failed to add address.");
      });
  };

  // Delete Address
  const deleteAddress = (id) => {
    if (!window.confirm("Delete this address?")) return;

    axios
      .delete(`${API_URL}/addresses/${id}`)
      .then(() => {
        loadAddresses();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Start Editing
  const startEdit = (item) => {
    setEditingId(item.id);

    setEditAddress({
      full_name: item.full_name,
      phone: item.phone,
      address: item.address,
      city: item.city,
      state: item.state,
      zip_code: item.zip_code,
      country: item.country
    });
  };

  // Edit Form Change
  const handleEditChange = (e) => {
    setEditAddress({
      ...editAddress,
      [e.target.name]: e.target.value
    });
  };

  // Save Edited Address
  const updateAddress = () => {
    axios
      .put(`${API_URL}/addresses/${editingId}`, editAddress)
      .then(() => {
        alert("Address Updated Successfully");
        setEditingId(null);
        setEditAddress(emptyAddress);
        loadAddresses();
      })
      .catch((err) => {
        console.log(err);
        alert("Failed to update address.");
      });
  };

  return (
    <div className="addresses-page">

      <section className="addresses-hero">
        <div className="addresses-overlay">
          <h1>Saved Addresses</h1>
          <p>Manage your delivery addresses for faster checkout.</p>
        </div>
      </section>

      <section className="addresses-section">
        <div className="addresses-container">

          {/* Add Address Form */}

          <form className="address-form" onSubmit={addAddress}>

            <input
              type="text"
              name="full_name"
              placeholder="Full Name"
              value={newAddress.full_name}
              onChange={handleChange}
            />

            <input
              type="text"
              name="phone"
              placeholder="Phone Number"
              value={newAddress.phone}
              onChange={handleChange}
            />

            <textarea
              name="address"
              rows="4"
              placeholder="Complete Address"
              value={newAddress.address}
              onChange={handleChange}
            />

            <input
              type="text"
              name="city"
              placeholder="City"
              value={newAddress.city}
              onChange={handleChange}
            />

            <input
              type="text"
              name="state"
              placeholder="State"
              value={newAddress.state}
              onChange={handleChange}
            />

            <input
              type="text"
              name="zip_code"
              placeholder="Zip Code"
              value={newAddress.zip_code}
              onChange={handleChange}
            />

            <input
              type="text"
              name="country"
              placeholder="Country"
              value={newAddress.country}
              onChange={handleChange}
            />

            <button type="submit">
              <FaPlus /> Add Address
            </button>

          </form>

          {/* Address List */}

          <div className="address-grid">

            {addresses.map((item) => (

              <div className="address-card" key={item.id}>

                <FaMapMarkerAlt className="address-icon" />

                {editingId === item.id ? (

                  <>
                    <input
                      type="text"
                      name="full_name"
                      value={editAddress.full_name}
                      onChange={handleEditChange}
                    />

                    <input
                      type="text"
                      name="phone"
                      value={editAddress.phone}
                      onChange={handleEditChange}
                    />

                    <textarea
                      name="address"
                      rows="3"
                      value={editAddress.address}
                      onChange={handleEditChange}
                    />

                    <input
                      type="text"
                      name="city"
                      value={editAddress.city}
                      onChange={handleEditChange}
                    />

                    <input
                      type="text"
                      name="state"
                      value={editAddress.state}
                      onChange={handleEditChange}
                    />

                    <input
                      type="text"
                      name="zip_code"
                      value={editAddress.zip_code}
                      onChange={handleEditChange}
                    />

                    <input
                      type="text"
                      name="country"
                      value={editAddress.country}
                      onChange={handleEditChange}
                    />

                   <div className="address-actions">

  <button
    type="button"
    className="save-btn"
    onClick={updateAddress}
  >
    <FaSave />
    Save
  </button>

  <button
    type="button"
    className="cancel-btn"
    onClick={() => {
      setEditingId(null);
      setEditAddress(emptyAddress);
    }}
  >
    <FaTimes />
    Cancel
  </button>

</div>
                  </>

                ) : (

                  <>
                    <h3>{item.full_name}</h3>

                    <p>{item.phone}</p>

                    <p>{item.address}</p>

                    <p>
                      {item.city}, {item.state}
                    </p>

                    <p>{item.zip_code}</p>

                    <p>{item.country}</p>

                <div className="address-actions">

  <button
    type="button"
    className="edit-btn"
    onClick={() => startEdit(item)}
  >
    <FaEdit />
    Edit
  </button>

  <button
    type="button"
    className="delete-btn"
    onClick={() => deleteAddress(item.id)}
  >
    <FaTrash />
    Delete
  </button>

</div>
                  </>

                )}

              </div>

            ))}

          </div>

        </div>
      </section>

    </div>
  );
}

export default Addresses;